import { useMemo } from 'react';
import { useUser } from './useUser';
import { useSelectedUser } from '../contexts/SelectedUserContext';

export const useAutomationUserContext = () => {
    const user = useUser();
    const { selectedUser } = useSelectedUser();

    const isInternalUser = useMemo(() =>
        user?.role === 'internal' || user?.role === 'admin'
        , [user]);

    const isInternalUserViewingExternal = useMemo(() =>
        isInternalUser && !!selectedUser
        , [isInternalUser, selectedUser]);

    const effectiveUserId = useMemo(() => {
        if (isInternalUserViewingExternal && selectedUser?.id) {
            return selectedUser.id;
        }
        return user?.id || '';
    }, [isInternalUserViewingExternal, selectedUser, user]);

    // For APIs that need to know who the "target" is (the external person we are looking at)
    const targetUserId = useMemo(() => {
        if (isInternalUser) {
            return selectedUser?.id || '';
        }
        return user?.id || '';
    }, [isInternalUser, selectedUser, user]);

    return {
        user,
        selectedUser,
        isInternalUser,
        isInternalUserViewingExternal,
        effectiveUserId,
        targetUserId,
    };
};
